import { fetchApi } from '@/config/axiosSetting';
import {
  GetBodyCustomerAttachedImagesQueryParamsType,
  GetBodyCustomerAttachedImagesQueryResponseType,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyCustomerAttachedImages/getBodyCustomerAttachedImagesQuery.type';

export const getBodyCustomerAttachedImagesQueryFunction = (
  params: GetBodyCustomerAttachedImagesQueryParamsType,
): Promise<GetBodyCustomerAttachedImagesQueryResponseType> => {
  return fetchApi.get(
    `/body/reports/${params.id}/images/customer/additional/vehicle/`,
  );
};
